<div>
  <!--Column Layout-->
  <div layout="column" [ngbTooltip]="totalsTooltipTmpl" openDelay="300" triggers="hover">

    <div
      class="margin-bottom-5 br-caption-1 font-weight-400 totals-span-container text-ellipsis layout-row layout-align-start-center">

      <bringoz-icon iconName="weight" class="margin-right-5 gray-102"></bringoz-icon>

      <span class="br-body-1">{{weight >= 0 ? (weight | number:weight % 1 > 0 ? '1.0-1' : '1.0-0') : '-'}}</span>

      <span class="margin-left-5 br-body-1"
            *ngIf="extraWeight >=0">/ {{weight + extraWeight | number:(weight + extraWeight) % 1 > 0 ? '1.0-1' : '1.0-0' }}</span>

      <span *ngIf="weight || extraWeight" class="margin-left-5 br-body-1" translate>{{weightUnit}}</span>
    </div>

    <div *ngIf="!!dimensions"
         class="margin-bottom-5 br-caption-1 totals-span-container text-ellipsis layout-row layout-align-start-center">
      <bringoz-icon iconName="volume" class="margin-right-5 gray-102"></bringoz-icon>
      <span>{{dimensions?.cube >= 0 ? (dimensions?.cube | number:dimensions?.cube % 1 > 0 ? '1.0-1' : '1.0-0') : '-'}}</span>

      <span class="margin-left-5 br-body-1"
            *ngIf="extraDimensions?.cube >= 0">/ {{(dimensions?.cube || 0) + (extraDimensions?.cube || 0) | number:((dimensions?.cube || 0) + (extraDimensions?.cube || 0)) % 1 > 0 ?'1.0-1' : '1.0-0' }}</span>

      <span *ngIf="dimensions?.cube || extraDimensions?.cube" class="margin-left-5 br-body-1"
            translate>{{volumeUnit}}</span>
    </div>

    <div *ngIf="!dimensions" layout="row" layout-align="start center"
         class="margin-bottom-5 br-caption-1 totals-span-container text-ellipsis layout-row layout-align-start-center">
      <bringoz-icon iconName="volume" class="margin-right-5 gray-102"></bringoz-icon>
      <span>{{volume | bringozVolume:true}}</span>
    </div>

    <div
      class="margin-bottom-5 br-caption-1 font-weight-400 totals-span-container text-ellipsis layout-row layout-align-start-center">
      <bringoz-icon iconName="package-outline" class="margin-right-5 gray-102"></bringoz-icon>
      <span class="br-body-1">{{numberOfPackages >= 0 ? numberOfPackages : '-' }}</span>
      <span class="margin-left-5 br-body-1"
            *ngIf="extraNumberOfPackages>=0">/ {{numberOfPackages + extraNumberOfPackages}}</span>
    </div>

    <div *ngIf="numberOfSpots" class="br-caption-1 font-weight-400 totals-span-container text-ellipsis layout-row layout-align-start-center">
      <bringoz-icon iconName="spot" class="margin-right-5 gray-102"></bringoz-icon>
      <span class="br-body-1">{{numberOfSpots >= 0 ? numberOfSpots : '-' }}</span>
      <span class="margin-left-5 br-body-1"
            *ngIf="extraNumberOfSpots>=0">/ {{numberOfSpots + extraNumberOfSpots}}
      </span>

    </div>

    <div *ngIf="numberOfPallets" class="br-caption-1 font-weight-400 totals-span-container text-ellipsis layout-row layout-align-start-center">
      <bringoz-icon iconName="pallets" class="margin-right-5 gray-102"></bringoz-icon>
      <span class="br-body-1">{{numberOfPallets >= 0 ? numberOfPallets : '-' }}</span>
      <span class="margin-left-5 br-body-1"
            *ngIf="extraNumberOfPallets>=0">/ {{numberOfPallets + extraNumberOfPallets}}
      </span>

    </div>

  </div>

  <ng-template #totalsTooltipTmpl>
    <div layout="column" layout-align="center start" class="gap-5 layout-column layout-align-center-start">
      <div *ngFor="let subVolume of subVolumeList"
           class="layout-row layout-align-start-center gap-5">

        <ng-container *ngIf="!!subVolume.labels">

          <app-bringoz-tag *ngFor="let labelName of subVolume.labels"
                           [name]="labelName"
                           [color]="labelsMap[labelName].color">

          </app-bringoz-tag>

        </ng-container>

        <div class="layout-row layout-align-start-center">
          <bringoz-icon iconName="weight" class="margin-right-5 gray-102"></bringoz-icon>
          <span class="br-body-1">{{subVolume.weight | bringozWeight:true}}</span>
        </div>

        <div class="layout-row layout-align-start-center">
          <bringoz-icon iconName="volume" class="margin-right-5 gray-102"></bringoz-icon>
          <span class="br-body-1">{{subVolume.volume | bringozVolume:true}}</span>
        </div>


      </div>
    </div>

  </ng-template>


</div>
